if (!customElements.get('load-more-products')) {
  customElements.define('load-more-products', class LoadMoreProducts extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.load-more__button');
      this.noMoreButton = this.querySelector('.button--no-more');
      this.productGrid = document.querySelector('#product-grid');
      this.paginationWrapper = this.closest('.collection')?.querySelector('.pagination-wrapper');
      this.section = this.closest('[id^="shopify-section-"]');
      this.sectionId = this.section?.id.replace('shopify-section-', '');
      this.spinner = null;
    }

    connectedCallback() {
      this.button?.addEventListener('click', this.loadMore.bind(this));
    }

    setLoadingState(isLoading) {
      if (!this.button) return;

      this.button.setAttribute('aria-disabled', String(isLoading));
      this.button.classList.toggle('loading', isLoading);

      if (!this.spinner) {
        this.spinner = this.button.querySelector('.loading-spinner');
      }

      this.spinner?.classList.toggle('hidden', !isLoading);
    }

    async fetchNextPage(nextUrl) {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      const response = await fetch(url.toString());
      const text = await response.text();
      return new DOMParser().parseFromString(text, 'text/html');
    }

    appendProducts(products) {
      const scrollY = window.scrollY || window.pageYOffset;

      products.forEach(product => {
        const clone = product.cloneNode(true);
        clone.style.opacity = '1';
        clone.style.transform = '';
        this.productGrid.appendChild(clone);
      });

      requestAnimationFrame(() => window.scrollTo(0, scrollY));
    }

    updatePagination(doc) {
      const newPaginationWrapper = doc.querySelector('.pagination-wrapper');
      if (!newPaginationWrapper) return false;

      this.paginationWrapper.innerHTML = newPaginationWrapper.innerHTML;

      const newPage = newPaginationWrapper.dataset.page;
      if (newPage) {
        this.paginationWrapper.dataset.page = newPage;
      }

      return !!newPaginationWrapper.querySelector('.pagination__item--prev');
    }

    replaceWithNoMoreButton() {
      this.button.classList.add('hidden');
      this.noMoreButton.classList.remove('hidden');
    }

    async loadMore() {
      if (!this.paginationWrapper || !this.sectionId) return;

      const nextLink = this.paginationWrapper.querySelector('.pagination__item--prev');
      if (!nextLink) return;

      const nextUrl = nextLink.getAttribute('href');
      if (!nextUrl) return;

      this.setLoadingState(true);

      try {
        const doc = await this.fetchNextPage(nextUrl);
        const newProducts = doc.querySelectorAll('#product-grid .product-grid__item');

        if (newProducts.length > 0) {
          this.appendProducts(newProducts);
        }

        const hasNextPage = this.updatePagination(doc);
        if (!hasNextPage) {
          this.replaceWithNoMoreButton();
          return;
        }

      } finally {
        this.setLoadingState(false);
      }
    }
  });
}
